import { throwResponseError } from '@/utils/index';

export interface SearchReportResponseData {
  report: {
    permalink: string;
  };
}

interface SearchBodyOpts {
  'h-captcha-response'?: string;
}

interface ReportFlags {
  report_flags: unknown[];
}

export type PersonRequestBody = {
  report_type: 'detailed_person_report';
  meta: {
    person_id: string;
    report_flags: string[];
  };
} & SearchBodyOpts;

export type PhoneSearchRequestBody = {
  report_type: 'reverse_phone_report' | 'phone_fraud_report';
  meta: {
    phone_number: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type UsernameSearchRequestBody = {
  report_type: 'username_report';
  meta: {
    username: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type EmailSearchRequestBody = {
  report_type: 'social_network_report' | 'email_fraud_report';
  meta: {
    email: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type IpSearchRequestBody = {
  report_type: 'ip_fraud_report';
  meta: {
    ip_address: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type UrlSearchRequestBody = {
  report_type: 'url_fraud_report';
  meta: {
    url: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type PropertySearchRequestBody = {
  report_type: 'property_report';
  meta: {
    address?: string;
    city?: string;
    state?: string;
    zip_code?: string;
    property_id?: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type VehicleSearchRequestBody = {
  report_type: 'vehicle_report';
  meta: {
    vin?: string;
    tag?: string;
    year?: string;
    make?: string;
    model?: string;
    trim?: string;
    licensePlate?: string;
    state?: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type ObituaryRequestBody = {
  report_type: 'obituary_report';
  meta: {
    obituary_id: string;
    report_flags: [];
  };
} & SearchBodyOpts;

export type UnclaimedMoneyRequestBody = {
  report_type: 'unclaimed_money_report';
  meta: {
    first_name: string;
    last_name: string;
    state: string;
    multi_state_search?: boolean;
  } & ReportFlags;
} & SearchBodyOpts;

export type ContactSearchRequestBody = {
  report_type: 'contact_report';
  meta: {
    contact_id?: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type AncestorRequestBody = {
  report_type: 'ancestry_report';
  meta: {
    first_name: string;
    last_name: string;
    city: string;
    state: string;
    country: string;
    date_of_birth: string;
    date_of_death: string;
    ip_address: string;
    family_search_id: string;
  } & ReportFlags;
} & SearchBodyOpts;

export type ReportSearchRequestBody =
  | PersonRequestBody
  | EmailSearchRequestBody
  | PhoneSearchRequestBody
  | PropertySearchRequestBody
  | UsernameSearchRequestBody
  | VehicleSearchRequestBody
  | ObituaryRequestBody
  | ContactSearchRequestBody
  | UnclaimedMoneyRequestBody
  | AncestorRequestBody
  | IpSearchRequestBody
  | UrlSearchRequestBody;

export async function searchReport(
  body: ReportSearchRequestBody
): Promise<SearchReportResponseData> {
  const searchReportResponse = await fetch('/api/v5/reports', {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (searchReportResponse.status !== 200) {
    throwResponseError(
      `Error creating ${body.report_type}`,
      searchReportResponse,
      undefined,
      { body }
    );
  }

  return await searchReportResponse.json();
}
